export default "__VITE_ASSET__YRm3qEWo__"